import styled from 'styled-components';

export const StdLoading = styled.div`
  position: fixed;
  inset: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 96px;
    height: 96px;
    stroke-width: 2.08333%;
    .inner {
      stroke: rgb(223, 228, 232);
    }
    .outer {
      stroke: rgb(91, 8, 164);
      stroke-dasharray: 43.9823, 43.9823;
      transform-origin: center center;
      animation: 2s cubic-bezier(0.41, 0.2, 0.16, 0.59) 0s infinite normal none running spinner1,
        2s cubic-bezier(0.63, 0, 0.58, 1) 0s infinite normal none running spinner2;
    }
  }
  @keyframes spinner1 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(2turn);
    }
  }
  @keyframes spinner2 {
    0% {
      stroke-dashoffset: 43.9823;
    }

    50% {
      stroke-dashoffset: 10.9956;
    }

    100% {
      stroke-dashoffset: 43.9823;
    }
  }
`;
